/**
 * Action to do on entity
 */
export enum ActionType {
  ADD_UPDATE,
  DELETE
}
